<h2 mat-dialog-title>Add Docs To: {{reviewSetName}}</h2>
<mat-dialog-content>
  <div>Total Docs Selected: {{selectedDocCount}}</div>
  <div style="margin-top: 10px; margin-bottom: 10px;">
    <mat-checkbox [(ngModel)]="expandDocs">Expand to Entire E-mail Family: {{expandedDocCount}}</mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="ok()">OK</button>
  <button mat-raised-button color="secondary" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
